<template>
  <validation-provider
    v-slot="{ errors, reset }"
    class="validate-tooltip grid-x"
    :name="String(fieldName).toLowerCase()"
    :rules="{ required: { allowFalse: false }}"
    :vid="$props.id || $attrs.id"
    mode="eager"
  >
    <checkbox
      v-model="localValue"
      v-bind="{ ...$props, ...$attrs }"
      v-on="$listeners"
    >
      <slot />
    </checkbox>
    <transition name="fade">
      <span
        v-if="errors[0]"
        class="cell shrink error popover"
        tabindex="0"
        @click="reset()"
        v-text="errors[0]"
      />
    </transition>
  </validation-provider>
</template>

<script>
import Checkbox from '@/components/common/Checkbox';
export default {
  name: 'CheckboxWithValidation',
  components: {
    Checkbox,
  },
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
  },
  props: {
    rules: {
      type: [ String, Array, Object ],
      default: '',
    },
    modelValue: {
      type: [ String, Number, Boolean, Array ],
      default: '',
    },
  },
  computed: {
    fieldName() {
      return this.$attrs['data-vv-as'] || this.$props.name || this.$attrs.placeholder;
    },
    localValue: {
      get() {
        return this.modelValue;
      },
      set(modelValue) {
        this.$emit('input', modelValue);
      },
    },
  },
};
</script>

<style>

</style>